module.exports = __webpack_public_path__ + "media/customizations/sundancenorthlife/logo-a3cbc1aa17e32a0f87fd57f3e92c0424.png";